export default "__VITE_ASSET__Cm8QH3d$__"